import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import BackButton from "../../img/icons/icon_blue_back.svg";
import moment from "moment";
import "moment/locale/hi";
import "moment/locale/mr";

function UpdateLanguage3({ question, choices, qKey, selectedChoice = null }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [currentChoice, setChoice] = useState(
    selectedChoice || { value: null, text: null }
  );
  const handleChange = (choice) => setChoice(choice);

  const Choices = choices.map((choice, index) => {
    return (
      <li key={index}>
        <label>
          <input
            type="radio"
            name={qKey}
            value={choice.value}
            checked={currentChoice.value === choice.value}
            onChange={() => handleChange(choice)}
          />
          <span className="dot"></span>
          <span className="txt">{choice.text}</span>
        </label>
      </li>
    );
  });

  // update language
  const changeLanguage = async () => {
    const token = "Bearer " + localStorage.getItem("token");
    const patientId = JSON.parse(localStorage.getItem("pid"));
    const PATCH_URL = `/api/v1/users/profile/${patientId}`;
    try {
      const data = {
        language: currentChoice.value,
      };
      const response = await fetch(`${PATCH_URL}`, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=utf-8",
          Authorization: token.replace(/['"]+/g, ""),
        },
        body: JSON.stringify(data),
        credentials: "include",
      });
      const res = await response.json();
      console.log(res);

      if (!response.status === 200) {
        const error = new Error(response.error);
        throw error;
      } else {
        console.log("Changing locale to: " + currentChoice.value);
        moment.locale(currentChoice.value);
        i18n.changeLanguage(currentChoice.value);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleClick = () => {
    changeLanguage();
    //history.push('/onboarding')
  };

  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <Link to="/setting" className="icon_left d-flex align-items-center">
            <img src={BackButton} alt="" className="img-fluid" />
            <span className="head_title">{t("sidenav.LANGUAGE.detail")}</span>
          </Link>
        </div>
      </header>
      <div className="body_content">
        <div className="inner_body ">
          <h3 className="headtitle">{question}</h3>
          <ul className="list-unstyled list_radio_btn">{Choices}</ul>
          <div className="btn_block bottom_button d-flex justify-content-center">
            <button
              className="btn btn_primary nextstep_cta"
              disabled={currentChoice.value == null}
              onClick={() => history.push("/setting")}
            >
              {t("appointment.BUTTON.cancel")}
            </button>
            <button
              className="btn btn_primary nextstep_cta"
              disabled={currentChoice.value == null}
              onClick={handleClick}
              data-bs-toggle="modal"
              data-bs-target="#modal_language"
            >
              {t("appointment.BUTTON.save")}
            </button>
          </div>
        </div>
      </div>
      <div className="custom_modal modal fade text-center" id="modal_language">
        <div className="modal-dialog d-flex align-items-center top-0">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                id="modal_language"
                type="button"
                className="btn-close btn-dark-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => history.push("/setting")}
              ></button>
            </div>
            <div className="modal-body">
              <div className="content_modal text-start p-2">
                <h3 className="maintitle maintitle_txt_color_black text-center pb-3">
                  {t("sidenav.LANGUAGE.message")}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdateLanguage3;
